import type { DependencyContainer } from 'tsyringe'
import { ref } from 'vue'
import { DITokens } from '@/di'
import type { ESPokemonSingleProduct } from '@ka-nabellinc/tcg-platform-es-schema'

type InitialData = {
  pokemonSingleProduct: ESPokemonSingleProduct
  samePokemonSingleProducts: ESPokemonSingleProduct[]
  samePokemonSingleProductsTotal: number
  preEvolutionPokemonSingleProducts: ESPokemonSingleProduct[]
  preEvolutionPokemonSingleProductsTotal: number
  evolutionPokemonSingleProducts: ESPokemonSingleProduct[]
  evolutionPokemonSingleProductsTotal: number
}

const DEFAULT_SIZE = 15

export const usePokemonSingleRelatedProducts = (container: DependencyContainer, initialData: InitialData) => {
  const gateway = container.resolve(DITokens.ElasticsearchGateway)
  const {
    pm_card: {
      pm_card_pre_evolution_pokemon_unique_id,
      pm_card_pokemon_unique_id
    }
  } = initialData.pokemonSingleProduct

  // 同一カード
  const samePokemonSingleProductsPage = ref(1)
  const samePokemonSingleProducts = ref<ESPokemonSingleProduct[]>(initialData.samePokemonSingleProducts)
  const samePokemonSingleProductsTotal = ref(initialData.samePokemonSingleProductsTotal)
  const fetchSamePokemonSingleProductsNextPage = async () => {
    const nextPage = samePokemonSingleProductsPage.value + 1
    const from = samePokemonSingleProducts.value.length
    const { hits } = await gateway.getSamePokemonSingleProducts(initialData.pokemonSingleProduct, DEFAULT_SIZE, from)

    samePokemonSingleProducts.value = [
      ...samePokemonSingleProducts.value,
      ...hits
    ]
    samePokemonSingleProductsPage.value = nextPage
  }

  // 進化前
  const preEvolutionPokemonSingleProductsPage = ref(1)
  const preEvolutionPokemonSingleProducts = ref<ESPokemonSingleProduct[]>(initialData.preEvolutionPokemonSingleProducts)
  const preEvolutionPokemonSingleProductsTotal = ref(initialData.preEvolutionPokemonSingleProductsTotal)
  const fetchPreEvolutionPokemonSingleProductsNextPage = async () => {
    if (typeof pm_card_pre_evolution_pokemon_unique_id !== 'number') return
    const nextPage = preEvolutionPokemonSingleProductsPage.value + 1
    const from = preEvolutionPokemonSingleProducts.value.length
    const { hits } = await gateway.getPokemonSingleProductsByPokemonUniqueId(pm_card_pre_evolution_pokemon_unique_id, DEFAULT_SIZE, from)

    preEvolutionPokemonSingleProducts.value = [
      ...preEvolutionPokemonSingleProducts.value,
      ...hits
    ]
    preEvolutionPokemonSingleProductsPage.value = nextPage
  }

  // 進化後
  const evolutionPokemonSingleProductsPage = ref(1)
  const evolutionPokemonSingleProducts = ref<ESPokemonSingleProduct[]>(initialData.evolutionPokemonSingleProducts)
  const evolutionPokemonSingleProductsTotal = ref(initialData.evolutionPokemonSingleProductsTotal)
  const fetchEvolutionPokemonSingleProductsNextPage = async () => {
    if (typeof pm_card_pokemon_unique_id !== 'number') return
    const nextPage = evolutionPokemonSingleProductsPage.value + 1
    const from = evolutionPokemonSingleProducts.value.length
    const { hits } = await gateway.getPokemonSingleProductsByPreEvolutionPokemonUniqueId(pm_card_pokemon_unique_id, DEFAULT_SIZE, from)

    evolutionPokemonSingleProducts.value = [
      ...evolutionPokemonSingleProducts.value,
      ...hits
    ]
    evolutionPokemonSingleProductsPage.value = nextPage
  }

  return {
    samePokemonSingleProducts,
    samePokemonSingleProductsTotal,
    fetchSamePokemonSingleProductsNextPage,

    preEvolutionPokemonSingleProducts,
    preEvolutionPokemonSingleProductsTotal,
    fetchPreEvolutionPokemonSingleProductsNextPage,

    evolutionPokemonSingleProducts,
    evolutionPokemonSingleProductsTotal,
    fetchEvolutionPokemonSingleProductsNextPage
  }
}
